module.exports = __webpack_public_path__ + "static/media/arrowup-white.cf7636c6.svg";